module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/onboarding/components/onboarding-page/onboarding-page.component.scss
// module id = ./src/app/onboarding/components/onboarding-page/onboarding-page.component.scss
// module chunks = main